<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>

<tbody>
<tr><td>
<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIA</strong>
</p>
<p>
    Zawarta w Łodzi, pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>
  , z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>, zwaną w dalszej części Umowy <strong>Zleceniodawcą</strong>
</p>
<p>
  a​ Panem/Panią: {{imieNazwisko}}
  <br/>
  adres zamieszkania: {{zamieszkany}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  Nr rachunku bankowego: {{nrRachunku}}
  <br/>
  zwanym/zwaną w dalszej części umowy <strong>Zleceniobiorcą</strong> o następującej treści:
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p>
<ol>
  <li>
    Zleceniodawca, zleca prowadzenie, w okresie od dnia rozpoczęcia współpracy do {{umowaDo}}, 
    zajęć ogólnorozwojowych Judo.
  </li>
  <li>
    Łączny wymiar godzin lekcyjnych do wykonania będzie określony każdorazowo przez Zleceniodawcę z 1 tygodniowym wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.
  </li>
  <li>
    Za jednostkę obliczeniową przyjmuje się 60 minut zajęć według ustalonego planu wraz z czynnościami dodatkowymi związanymi z organizacją zajęć oraz wypełnianiem raportów po zajęciach.
  </li>
  <li>
    Celem zapewnienia warunków do wykonania zlecenia Zleceniodawca zobowiązuje się do: udostępnienia sal dydaktycznych w salach położonych w szkołach publicznych w lokalizacjach określonych w harmonogramie pracy przedstawianych przez Zleceniodawcę do akceptacji Zleceniobiorcy.
  </li>
</ol>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>
    Zlecone zajęcia Zleceniobiorca będzie wykonywał osobiście i nie może powierzyć ich w całości lub części innym osobom bez pisemnej zgody Zleceniodawcy. Zleceniobiorca zobowiązuje się nie powierzać zleconych w niniejszej umowie czynności do wykonania osobom trzecim. Naruszenie, zakazu, o którym mowa w ust. 1 spowoduje, iż osoba trzecia nie zostanie dopuszczona do wykonania jakichkolwiek czynności i nie otrzyma z tego tytułu żadnego wynagrodzenia.
  </li>
  <li>
    Zlecenie nie będzie wykonywane w siedzibie Zleceniodawcy. W przypadku wykonywania zlecenia w siedzibie Zleceniodawcy lub miejscu przez niego wyznaczonym, Zleceniobiorca oświadcza, że zna przepisy i zasady bezpieczeństwa i higieny pracy i zobowiązuje się do ich przestrzegania, a w szczególności do:
  </li>
  <ol type="a">
    <li>
      wykonywania zlecenia w sposób zgodny z przepisami i zasadami bezpieczeństwa i higieny pracy;
    </li>
    <li>
      dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;
    </li>
    <li>
      stosowania występujących w miejscu wykonywania zlecenia, dostępnych środków ochrony zbiorowej, a także używania własnych środków ochrony indywidualnej oraz odzieży i obuwia roboczego, o ile charakter wykonywanej pracy tego wymaga;
    </li>
    <li>
      niezwłocznego zawiadomienia Zleceniodawcy o zauważonym wypadku albo zagrożeniu życia lub zdrowia ludzkiego oraz ostrzeżenia współpracowników i innych osób znajdujących się w rejonie zagrożenia o grożącym im niebezpieczeństwie,
    </li>
    <li>
      współdziałania ze Zleceniodawcą w czasie ewakuacji, w sytuacji pożaru oraz w przypadku konieczności udzielenia pomocy ofiarom wypadków,
    </li>
    <li>
      prowadzenie dokumentacji zajęć: dziennika zajęć, listy obecności, testów, gier i zabaw, sprawozdania z realizacji zajęć oraz do terminowego wykonywania wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych,
    </li>
    <li>
      realizowanie celów projektu w zakresie zajęć poprzez:
    </li>
    <ul>
      <li>
        prowadzenie zajęć ogólnorozwojowych z zakresu sztuk walki oraz judo dla dzieci i młodzieży,
      </li>
      <li>
        motywowanie ucznia do samodzielnej pracy i przezwyciężania trudności,
      </li>
      <li>
        kształcenie umiejętności niezbędnych do prawidłowego rozwoju fizycznego i umysłowego,
      </li>
      <li>
        kształcenie postawy badawczej,
      </li>
      <li>
        naukę w oparciu o materiały i wytyczne dostarczone przez osobę wyznaczoną przez Zleceniodawcę,
      </li>
      <li>
        prezentowanie efektów swojej pracy.
      </li>
    </ul>
  </ol>
  <li>
    Zleceniobiorca zobowiązany jest do rzetelnego przygotowania i prowadzenia zajęć  zgodnie z autorskim programem edukacyjnym oraz harmonogramem.
  </li>
  <li>
    Zleceniobiorca ponosi pełną odpowiedzialność za uczniów w czasie trwania zajęć.
  </li>
  <li>
    Zleceniobiorca odpowiedzialny jest za jakość i terminowość prowadzonych zajęć.
  </li>
  <li>
    Zleceniobiorca ponosi pełną odpowiedzialność za szkody wyrządzone przez swoje działania lub zaniechania podczas wykonywania przedmiotu umowy.
  </li>
  <li>
    Zleceniobiorca zobowiązany jest do bezzwłocznego informowania Zamawiającego o każdym przypadku uniemożliwiającym mu realizację zajęć zgodnie z harmonogramem.
  </li>
  <li>
    Zleceniobiorca zobowiązany jest do stosowania się do zapisów Ustawy z dnia 29 sierpnia 1997r o ochronie danych osobowych (tj. DZ.U. z 2002r .Nr 101. Poz. 926 ze zmianami).
  </li>
  <li>
    W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy, zobowiązuje się do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie,  nie później niż 3 dni przed planowanymi zajęciami.
  </li>
  <li>
    Zleceniodawca zobowiązuje się do zapewnienia ubezpieczenia OC z tytułu prowadzonej działalności.
  </li>
  <li>
    W przypadku braku możliwości realizowania przez Zleceniobiorcę przedmiotu umowy zgodnie z harmonogramem, spowodowanej usprawiedliwioną nieobecnością trwającą w miesiącu nie dłużej niż pięć dni roboczych w sumie lub następujących kolejno po sobie, przy czym przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym. Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nie odbytym zajęciom, w innym terminie uzgodnionym z Zamawiającym.
  </li>
  <li>
    Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
  </li>
  <li>
    W przypadku nie przyjścia na zajęcia określone w harmonogramie zaakceptowanym przez Zleceniobiorcę i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 1 dzień, Zleceniodawca może naliczyć Zleceniobiorcy karę w wysokości 200 zł (słownie złotych dwieście). w Takim przypadku Zleceniodawca może rozwiązać Umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. Zleceniodawca może ponadto dochodzić odszkodowania od Zleceniobiorcy z tytułu szkód poniesionych w wyniku zaistnienia tego typu sytuacji do wysokości dwukrotnej wartości zaistniałej szkody. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przyjścia na zajęcia.
  </li>
</ol>
<p align="center" style="margin-bottom: 0px;page-break-before: always;">
  <strong>§ 3 Wynagrodzenie</strong>
</p>
<ol>
<li>
Tytułem wynagrodzenia Zleceniobiorca otrzyma kwotę w wysokości uzależnionej od opcji:
</li>
<ol class="list-options">
  <li>
    58 zł brutto (słownie złotych: pięćdziesiąt osiem) za 1 przepracowaną godzinę zegarową, lub
  </li>
  <li>
    85 zł brutto (słownie złotych: osiemdziesiąt pięć) za 1 przepracowaną godzinę zegarową w przypadku jeżeli liczebność grupy podczas prowadzonych zajęć liczyła pomiędzy 10 a 13 dzieci zapisanych na zajęcia prowadzone przez Zleceniobiorcę, którego rodzic lub opiekun prawny ma ważną, podpisaną umowę ze Zleceniodawcą, na świadczenie usług zajęć ogólnorozwojowych Judo i jeżeli Zleceniobiorca dotrzymuje terminów wykonania czynności wyznaczonych przez Zleceniodawcę i prowadzi zajęcia zgodnie z wytycznymi przekazanymi przez Zleceniodawcę, lub
  </li>
  <li>
    115 zł brutto (słownie złotych: sto piętnaście) za 1 przepracowaną godzinę w przypadku jeżeli liczebność grupy podczas prowadzonych zajęć liczy co najmniej 14 dzieci zapisanych na zajęcia prowadzone przez Zleceniobiorcę, którego rodzic lub opiekun prawny ma ważną, podpisaną umowę ze Zleceniodawcą, na świadczenie usług zajęć ogólnorozwojowych Judo i jeżeli Zleceniobiorca dotrzymuje terminów czynności wyznaczonych przez Zleceniodawcę i prowadzi zajęcia zgodnie z wytycznymi przekazanymi przez Zleceniodawcę.
    Liczebność grup w poszczególnych miesiącach badana będzie w ostatnim tygodniu zajęć w danym miesiącu.
  </li>
  </ol>
  <li>
  Wypłata wynagrodzenia nastąpi po wykonaniu przedmiotu umowy i potwierdzeniu jej wykonania przez Zleceniodawcę, złożeniu sprawozdania z wykonania, na podstawie przedłożonych przez Zleceniobiorcę rachunków, płatnego w terminie do 10 dni po akceptacji wykonania zlecenia przez Zleceniodawcę.Wynagrodzenie będzie płatne przelewem na numer konta bankowego Zleceniobiorcy wskazanego powyżej.
  </li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Szkody i ich usuwanie</strong>
</p>
<p>
  W razie niedotrzymania terminu Zleceniobiorca odpowiada za szkody poniesione przez Zleceniodawcę, natomiast przy
  stwierdzeniu błędów i wad przedmiotu umowy – zobowiązany jest do bezpłatnego ich usunięcia.
</p>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Okres wypowiedzenia</strong>
</p>
<p>
  Strony mogą rozwiązać Umowę z zachowaniem 1-miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Absencje i powiadamianie o nich</strong>
</p>
<ol>
  <li>
W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy, zobowiązuje się do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie,  nie później niż 3 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonania zlecenia opisanego w niniejszej umowie.
  </li>
  <li>
W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 3 dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia, powiadomić o takiej sytuacji Zleceniodawcę.
  </li>
  <li>
W przypadku niemożliwości realizowania przez Zleceniobiorcę przedmiotu umowy zgodnie z harmonogramem, spowodowanej usprawiedliwioną nieobecnością trwającą w miesiącu nie dłużej niż pięć dni roboczych w sumie lub następujących kolejno po sobie, przy czym przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym. Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nie odbytym zajęciom, w innym terminie uzgodnionym z Zamawiającym.
  </li>
  <li>
Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
  </li>
  <li>
W przypadku nie przyjścia na zajęcia określone w harmonogramie zaakceptowanym przez Zleceniobiorcę i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 1 dzień, Zleceniodawca może naliczyć Zleceniobiorcy karę w wysokości 200 zł (słownie złotych dwieście). w Takim przypadku Zleceniodawca może rozwiązać Umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. Zleceniodawca może ponadto dochodzić odszkodowania od Zleceniobiorcy z tytułu szkód poniesionych w wyniku zaistnienia tego typu sytuacji do wysokości dwukrotności wartości zaistniałej szkody. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przyjścia na zajęcia.
  </li>
</ol>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Prowadzenie działalności gospodarczej</strong>
</p>
<ol>
<li>
Zleceniobiorca oświadcza, że nie prowadzi działalności gospodarczej w myśl Ustawy o swobodzie działalności gospodarczej (j.t. Dz. U. z 2010 r. Nr 220, poz.1447 z późn. zm.) w zakresie przedmiotu umowy.
</li>
<li>
Zleceniobiorca zobowiązuje się do niezwłocznego poinformowania Zleceniodawcy o zmianie stanu faktycznego określonego w ust. 1 w terminie 7 dni od dnia rozpoczęcia działalności gospodarczej.
</li>
<li>
Strony ustalają, że niniejsza umowa nie rodzi żadnych skutków w zakresie uprawnień pracowniczych wynikających ze stosunku pracy.
</li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Forma umowy</strong>
</p>
<ol>
  <li> 
    Zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.
  </li>
  <li>
    W sprawach nieuregulowanych niniejszą umową mają zastosowanie przepisy Kodeksu Cywilnego.
  </li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Właściwy Sąd</strong>
</p>
<p>
  Do rozpoznania sporów wynikających z niniejszej umowy właściwy będzie Sąd Powszechny w Łodzi.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Ilość umów</strong>
</p>
<p>
  Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
</p>
<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        {{zamawiajacy}}<br>
        <span style="margin-left: 15%;">(Zleceniodawca)</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 15%;">(Zleceniobiorca)</span>
    </div>
</div>



<div style="margin-top:5px;page-break-after: always;page-break-before: always;">
<p align="right">Dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}}</p>
<p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>
<br>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>Imiona i Nazwisko </strong><span>{{imieNazwisko}}</span></p>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>PESEL </strong><span>{{pesel}}</span></p>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>Seria i Nr dowodu osobistego </strong><span>{{nrDowodu}}</span>
<span class="caption">(proszę podać w przypadku braku nr PESEL)</span></p>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>Nr telefonu </strong><span>{{nrTelefonu}}</span></p>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>E-Mail </strong><span>{{email}}</span></p>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>Adres Zamieszkania </strong><span>{{zamieszkany}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>

<p style="margin-top:5px;margin-bottom: 5px;"><strong>Adres Korespondencyjny </strong><span>{{korespondencyjny}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>

<p style="margin-top:5px;margin-bottom: 5px;"><strong>Urząd Skarbowy </strong><span>{{urzadSkarbowy}}</span><br>
<span class="caption">(właściwy do przekazania rocznej informacji o dochodach i pobranych zaliczkach na podatek dochodowy)</span></p>
<p style="margin-top:5px;margin-bottom: 5px;"><strong>Nr rachunku bankowego </strong><span>{{nrRachunku}}</span></p>

<table style="border: 1px solid; text-align: left;">
<tbody>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
</td>
<td>
<p class="cell-in-first-table"><span>{{emeryt}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{rencista}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>3.1. Proszę wybrać orzeczony stopień niepełnosprawności<br>lub zaznaczyć nie dotyczy:</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{student}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>5. Umowa cywilno-prawna z Tutore Poland Sp. z o.o.<br>jest moim jedynym tytułem do ubezpieczenia</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{jedenyTytulDoUbezpieczenia.replace(/\s*\(.*$/, '')}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>6. Wnoszę o dobrowolne ubezpieczenie chorobowe</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>7. Jestem zatrudniony/a na umowę o pracę.</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>7.1. Nazwa i adres pracodawcy</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>7.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br>jest wyższe bądź równe krajowej płacy minimalnej:</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>8. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o.:</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>8.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia:</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
</td>
</tr>

</tbody>
</table>

<p></p>

<p>
  <span>
    Oświadczam, że dane zawarte w formularzu są zgodne ze stanem prawnym i faktycznym.
    Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji.
    Jestem świadoma/y odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy. Zobowiązuję się do poinformowania Zleceniodawcy
  </span>
  <strong>
    w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany.
  </strong>
</p></div>



<div style="margin-top:40px;page-break-before: always;">
<p align="center" class="subheading"><strong>Informacja o ochronie danych osobowych </strong></p>
<p>&nbsp;</p>
<p><span>
  Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 
  z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku 
  z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE og&oacute;lne rozporządzenie o ochronie danych, 
  (&bdquo;Rozporządzenie&rdquo;) informujemy, że Administratorem Danych Osobowych jest: 
</span></p>
<p>&nbsp;</p>
<p><em>
  <span>
    Tutore Poland Sp. z o.o. z siedzibą w Łodzi przy 
    ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
    wpisana do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
    sąd rejestrowy dla Łodzi Śr&oacute;dmieścia, XX Wydział Krajowego Rejestru Sądowego, 
    NIP: 7272812193.
  </span>
</em></p>
<p>
  <span>
    Kontakt z Administratorem Danych Osobowych możesz uzyskać pisemnie, 
    kierując korespondencję na powyższy adres lub elektronicznie, korzystając z adresu e-mail: 
  </span>
  <a href="mailto:kadry@szkolam.pl"><span>kadry@szkolamm.pl</span></a>
</p>
<p>&nbsp;</p>
<p><span>
  Dane osobowe są przetwarzane w celu zawarcia i realizacji zawartej umowy, 
  tj. na podstawie art. 6 ust. 1 lit. b &nbsp;Rozporządzenia. 
  Podanie danych jest dobrowolne, jednak konieczne w celu zawarcia i wykonania Umowy. 
  W związku z realizacją usług dane osobowe zostaną przekazane podmiotom zewnętrznym, 
  w tym w szczeg&oacute;lności dostawcom system&oacute;w i usług informatycznych, 
  bankom i operatorom płatności, podmiotom świadczącym usługi księgowe,prawne, audytowe, 
  konsultingowe, kurierom, oraz podmiotom powiązanym z Administratorem, 
  kt&oacute;rzy zajmują się realizacją zam&oacute;wień. Dane osobowe będą przechowywane 
  przez okres trwania umowy, a po jej zakończeniu przez czas wynikający z obowiązujących 
  przepis&oacute;w prawa lub do czasu przedawnienia wzajemnych roszczeń. Każda osoba, 
  kt&oacute;rej dane dotyczą ma prawo dostępu do swoich danych osobowych, żądania 
  ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu 
  wobec przetwarzania danych oraz prawo do przenoszenia danych. 
  W celu realizacji powyższych uprawnień należy skontaktować się 
  z Administratorem Danych Osobowych, korzystając z danych teleadresowych, 
  wskazanych powyżej. Osoba, kt&oacute;rej dane dotyczą ma także prawo wniesienia skargi 
  do organu nadzorczego, gdy uzna, iż przetwarzanie danych osobowych narusza przepisy prawa.
  </span></p>
</div>

<div style="margin-top: 40px; page-break-before: always;">

<p align="center">
  <strong>
    Upoważnienie<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    papierowej i elektronicznej
  </strong>
</p>
<p>&nbsp;</p>
<p>
  <span>
    Niniejszym upoważniam Pana/Panią {{imieNazwisko}}
    do przetwarzania danych osobowych zawartych 
    w poniżej wymienionych zbiorach danych osobowych 
    w wersji papierowej i elektronicznej:
  </span>
</p>
<p>
<ul>
  <li>
    zbiór danych osobowych: które uczęszczają na zajęcia ogólnorozwojowe Judo,
  </li>
  <li>
    zbiór danych osobowych: rodziców (opiekunowie prawni) dzieci uczęszczających na zajęcia ogólnorozwojowe Judo,
  </li>
</ul>
</p>
<p><span>w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami. </span></p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
</p>
<p>
  Naruszenie ww. obowiązków może skutkować  poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<p>
Upoważnienie jest ważne do odwołania.
</p>

<p style="font-style: italic;">
  Oświadczam, iż zapoznałem się z przepisami dotyczących ochrony danych osobowych, w szczególności Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) oraz wdrożonymi obowiązkami związanymi z obowiązującą w Tutore Poland Sp. z o.o. Polityką prywatności dot. przetwarzania danych osobowych.
</p>
<p style="font-style: italic;">
  Zobowiązuję się do przestrzegania w/w zasad oraz do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
</p>

</div>


</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaJudo',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zameldowany: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaDo: '',
      urzadSkarbowy: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
.list-options {
  counter-reset: item;
  margin-left: 0;
  padding-left: 0;
}
.list-options > li {
  display: block;
  margin-bottom: .5em;
  margin-left: 2em;
}
.list-options > li::before {
  display: inline-block;
  font-weight: bold;
  content: "Opcja " counter(item, upper-alpha) ": ";
  counter-increment: item;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaJudo.vue